export default __webpack_public_path__ + "static/media/welcome.e1dec783.png";